import React, { useState } from 'react';
import { Stack, Typography, ButtonBase, Menu, MenuItem, IconButton, Box } from '@mui/material';
import { RiArrowDownSLine, RiArrowUpSLine, RiMore2Fill } from 'react-icons/ri';
import { useTranslation } from 'services/localization';

export interface Props {
	open: boolean;
	onClick: () => void;
	onDelete?: () => void;
	heading: string;
}
const CollapseHeader = (props: Props) => {
	const { open, onClick, onDelete, heading } = props;
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const { t } = useTranslation();

	return (
		<Stack justifyContent="center" sx={{ position: 'relative' }}>
			<ButtonBase onClick={onClick}>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					sx={{
						background: (theme) => theme.palette.grey['100'],
						pl: 2,
						width: '100%',
						py: 1,
						pr: 1,
					}}
				>
					<Typography variant="body2" sx={{ fontWeight: 500 }}>
						{heading}
					</Typography>
					{!open ? <RiArrowDownSLine size={24} /> : <RiArrowUpSLine size={24} />}
				</Stack>
			</ButtonBase>
			{!!onDelete && (
				<Box sx={{ position: 'absolute', right: 32 }}>
					<IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
						<RiMore2Fill size={16} />
					</IconButton>
					<Menu
						open={!!anchorEl}
						id="header-menu"
						anchorEl={anchorEl}
						onClose={() => setAnchorEl(null)}
					>
						<MenuItem onClick={onDelete}>{t('common:actions.delete', 'Delete')}</MenuItem>
					</Menu>
				</Box>
			)}
		</Stack>
	);
};

export default CollapseHeader;
